import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { UserService } from '../services/user.service';
// import { ActivatedRoute } from '@angular/router';
@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit {
  userForm: FormGroup;
  // userId: string;
  constructor(
    private fb: FormBuilder,
    private userService: UserService,
    // private route: ActivatedRoute
  ) {
    this.userForm = this.fb.group({
      id: [''],
      firstName: [''],
      lastName: [''],
      email: ['']
    });
  }
  ngOnInit(): void {
    // this.userId = this.route.snapshot.paramMap.get('id');
    this.getUserData();
  }

  getUserData(): void {
    this.userService.getUser().subscribe(res => {
      if(res.result){
        var d = res.item;
        this.userForm.patchValue({
          id: d.id,
          firstName: d.firstName,
          lastName: d.lastName,
          email: d.email
        });
      }

    });
  }

  onUpdate(): void {
    this.userService.updateUser(this.userForm.value).subscribe(response => {
      if(response.result){
        alert('crm user updated');
      }
    });
  }
}
